<div
	class="flex gap-y-1"
	[class.flex-wrap]="multiline()"
	[class.overflow-hidden]="!multiline()"
	data-cy="c-breadcrumb"
>
	@for (
		breadcrumb of breadcrumbs() | breadcrumbEllipsis: effectiveMaxBreadcrumbs() : expanded();
		track index;
		let last = $last, first = $first, index = $index
	) {
		@if (!breadcrumb.label) {
			<button
				#breadcrumbItem
				class="flex items-center text-secondary-600 dark:text-secondary-900 cursor-pointer hover:text-secondary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-focus focus:z-10 shrink-0"
				data-cy="c-breadcrumb-item"
				[tabindex]="tabIndex()"
				(click)="toggleExpanded()"
				(keydown)="handleKeyDown($event)"
				[attr.aria-label]="'Show more breadcrumbs'"
			>
				<ng-container
					[ngTemplateOutlet]="content"
					[ngTemplateOutletContext]="{ breadcrumb, first, last }"
				></ng-container>
			</button>
		} @else if (last) {
			<span
				#breadcrumbItem
				class="flex items-center text-secondary-800 dark:text-secondary-900 cursor-default min-w-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-focus focus:z-10"
				data-cy="c-breadcrumb-item"
				[tabindex]="tabIndex()"
				(keydown)="handleKeyDown($event)"
				[attr.aria-current]="'page'"
			>
				<ng-container
					[ngTemplateOutlet]="content"
					[ngTemplateOutletContext]="{ breadcrumb, first, last }"
				></ng-container>
			</span>
		} @else if (!breadcrumb.link) {
			<span
				class="flex items-center text-secondary-600 dark:text-secondary-900 cursor-default shrink-0"
				data-cy="c-breadcrumb-item"
			>
				<ng-container
					[ngTemplateOutlet]="content"
					[ngTemplateOutletContext]="{ breadcrumb, first, last }"
				></ng-container>
			</span>
		} @else {
			<a
				#breadcrumbItem
				class="flex items-center text-secondary-600 dark:text-secondary-900 cursor-pointer hover:text-secondary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-focus focus:z-10 shrink-0 no-underline"
				data-cy="c-breadcrumb-item"
				[routerLink]="breadcrumb.link"
				[tabindex]="tabIndex()"
				(keydown)="handleKeyDown($event)"
				[attr.aria-label]="breadcrumb.label"
			>
				<ng-container
					[ngTemplateOutlet]="content"
					[ngTemplateOutletContext]="{ breadcrumb, first, last }"
				></ng-container>
			</a>
		}
	}
</div>

<ng-template #content let-breadcrumb="breadcrumb" let-first="first" let-last="last">
	<div class="flex items-center" [class.min-w-0]="last && !multiline()" data-cy="c-breadcrumb-link">
		@if (first) {
			@if (icon()) {
				<ui-icon
					class="dark:text-secondary-900"
					[icon]="icon()"
					size="xs"
					data-cy="c-breadcrumb-icon"
					[class.mr-1]="!expanded()"
				></ui-icon>
			}
		} @else {
			<ui-icon icon="x_arrow_right" size="xs" data-cy="c-breadcrumb-divider"></ui-icon>
		}
		@if (breadcrumb.label) {
			<span
				class="text-xs font-semibold mx-1 duration-300"
				[class.ml-0]="!icon() && first"
				[class.truncate]="last && !multiline()"
				>{{ breadcrumb.label }}</span
			>
		} @else {
			<span data-cy="c-breadcrumb-ellipsis" class="text-xs">{{ breadcrumb }}</span>
		}
	</div>
</ng-template>
